import VideoCard from '@/components/base/VideoCard';
import { getNewVideos } from '@/mocks/videos';

export default function LatestUpdates() {
  const latestVideos = getNewVideos();

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">最新上线</h2>
            <p className="text-sm text-foreground-500 mt-1">每日更新，追剧不停</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {latestVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}